import { Controller } from "@hotwired/stimulus"

// Pivots the sign-in CTA based on email domain. When the entered email
// ends with @switchgrowth.com, the password+submit area is replaced with
// the Google OAuth button (Switch employees auth via Google SSO, no password).
export default class extends Controller {
  static targets = ["email", "password", "clientCta", "adminCta"]
  // Set when a Switch user has signed in on this browser before — see OAuthController#create.
  static values = { remembered: Boolean }

  connect() {
    this.check()
  }

  check() {
    const value = (this.emailTarget.value || "").toLowerCase().trim()
    // Empty field → fall back to the remembered preference so Switch staff who've
    // signed in before see Google SSO immediately. Once they type, the domain decides,
    // so a returning/shared client who types their own email still gets password login.
    const isAdmin = value === "" ? this.rememberedValue : value.endsWith("@switchgrowth.com")
    this.clientCtaTarget.classList.toggle("hidden", isAdmin)
    this.adminCtaTarget.classList.toggle("hidden", !isAdmin)
    // Clear required/disabled on the hidden password field so the browser
    // doesn't block submit with a tooltip pointed at an invisible input.
    if (this.hasPasswordTarget) {
      this.passwordTarget.required = !isAdmin
      this.passwordTarget.disabled = isAdmin
    }
  }
}
